export default __webpack_public_path__ + "static/media/Cover2.f85e5b49.png";